<template>
    <div >
          <!-- ATTRIBUER UNE  ZONE A UN RESPONSABLE -->
        <v-dialog v-model="dialogAjoutZoneResponsable" max-width="80%" :overlay="true" scrollable persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>
                        <span >Attribuer une zone a un responsable {{userResponsable.nom}}</span>
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click.native="closeDialog()" dark><v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text v-loading="loading" element-loading-text="En cours d'enregistrement ..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                    <v-container fluid grid-list-md>
                        <v-layout row>
                            <v-flex md12>
                                <v-alert
                                        :value="true"
                                        type="warning"
                                >
                                    NB: La responsabilite d'une zone comporte egalement tous les sous zones qui la composent
                                </v-alert>
                            </v-flex>
                        </v-layout>
                       <v-layout wrap>
                           <v-flex md12 class="text-md-center" >
                               <div>
                                   <el-transfer
                                           style="text-align: left; display: inline-block"
                                           filterable
                                           filter-placeholder="Recherche"
                                           v-model="zoneSelect"
                                           :titles="['Zone libre', 'Zone selectionnee']"
                                           :left-default-checked="[2, 3]"
                                           :data="listeZone">
                                   </el-transfer>
                               </div>
                           </v-flex>

                           <v-flex md12  class="text-xs-right">
                                <v-btn dark color="grey"  @click="closeDialog()" >Annuler <v-icon right>remove_circle</v-icon></v-btn>
                                <v-btn icons dark color="green" @click="submitZone()" :disabled="!valid" >Ajouter <v-icon right>add</v-icon></v-btn>
                           </v-flex>

                       </v-layout>
                    </v-container>
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
        <!-- ATTRIBUER UNE  ZONE A UN RESPONSABLE -->
    </div>
</template>





<script>

    import Loading from '@/components/Loading';

    export default {
        components: {Loading},
        name: "ModalAttribuerZone",
        props: ["show","userResponsable"],

        data() {
            return {
                //data general
                domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
                user: JSON.parse(sessionStorage.getItem("userInfo")),
                roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
                loading: false,

                valid: true,
                dialogAjoutZoneResponsable: false,
                loading: false,
                listeZone: [],
                zoneSelect: [],
            
            }
        },
        computed: {
        },
       
        methods: {
             closeDialog()
            {
                this.$emit('close')
            },

            //charge les zones sans responsable 
            loadZone(){
                 let url = this.domaine + 'attribution/liste/zonelibre/'+this.userResponsable.id
                 this.$http.get(url).then(response => {
                    //console.log("listeZone")
                    //console.log(response.body.listeZone)
                    this.listeZone = response.body.listeZone
                })
            },

            submitZone(){
                this.loading = true
                var formdata = new FormData()
                formdata.append('zoneSelect', this.zoneSelect)
                formdata.append('userRespId', this.userResponsable.id)
                
                  let url = this.domaine + 'attribution/ajout/zone'
                this.$http.post(url,formdata).then(response => {
                    this.loading = false
                    this.closeDialog()
                     this.$notify({
                                  title: "Ajout de zone",
                                  message: 'Enregistrement effectué avec succès.',
                                  type: 'success',
                                  position: 'top-center'
                                })
                },
                (resp)=>{
                    this.closeDialog()
                     this.loading = false
                    this.$message.error("erreur serveur")
                })
            },

            //charge les zones d'un responsable 
            loadZoneResponsable(){
                let url = this.domaine + 'attribution/zone/responsable/'+ this.userResponsable.id
                this.$http.get(url).then(response => {
                   this.zoneSelect = response.body.zoneSelect
                }, (resp)=>{

                })
            }
        },

         watch: {
            show : function(newValue, oldvalue){
                if(newValue == true){
                     this.loadZone()
                    this.loadZoneResponsable()
                }
                this.dialogAjoutZoneResponsable = newValue
            }
        },


        mounted()
        {
           
           
        }

    };
</script>





// WEBPACK FOOTER //
// src/components/user/ModalAttribuerZone.vue